import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { updateFieldAction } from "../../../../../../modules/fields/action";
import "../../../../../../style";
import FieldForm from "./FieldForm";



class EditField extends Component {
  state = {
    successMessage: "",
    errorMessage: {}
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.fieldUpdated && nextProps.fieldUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  handleSubmit = formData => {
    this.props.updateFieldAction(formData);
  };

  render() {
    const { successMessage } = this.state;
    const { selectedField } = this.props;
    if (successMessage) {
      return <Redirect to="/farmsetup/farminformation/field-groups/fields" />;
    }
    return (
      <FieldForm
        buttonLabel="Update"
        formLabel="Edit field"
        fieldInfo={selectedField}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedField: state.fieldReducer.selectedField,
    fieldUpdated: state.fieldReducer.fieldUpdated
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateFieldAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditField);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/Fields/EditField.js